const ded = `
<h1>Artificial Intelligence (AI) Usage Policy on the DressDown Platform</h1>

<h2>Compliance with EU Legislation</h2>
<p>DressDown adheres to the legal standards of the European Union, including:</p>
<ul>
  <li>General Data Protection Regulation (GDPR): when processing personal data.</li>
  <li>Artificial Intelligence Act (AI Act): when using and implementing AI systems.</li>
  <li>Charter of Fundamental Rights of the European Union: especially Articles 7 (respect for private and family life) and 8 (protection of personal data).</li>
</ul>

<h2>Transparency and Labelling of AI-Generated Content</h2>
<p>All images created using artificial intelligence technologies must be clearly labeled: <strong>Generated by AI. Not a real photograph. Any resemblance is purely coincidental.</strong> This practice ensures transparency and user awareness, and aligns with the principles of fairness and honesty enshrined in EU law, notably Regulation (EU) 2019/1150 on promoting fairness and transparency for business users of online platforms, as well as the Code of Practice on Disinformation recommended by the European Commission.</p>
<p>Special attention is given to labeling content that could be perceived as journalistic, scientific, or politically significant, to avoid the spread of disinformation and protect users’ right to accurate information in accordance with the Charter of Fundamental Rights of the European Union (Article 11 — freedom of expression).</p>

<h2>Consent and Privacy Protection</h2>
<ul>
  <li>The use of real people’s images without explicit consent is prohibited, including:
    <ul>
      <li>Photos from personal accounts.</li>
      <li>Biometric data.</li>
      <li>Medical and intimate images.</li>
    </ul>
  </li>
  <li>We do not store or use sensitive personal data in generative systems.</li>
</ul>

<h2>Restrictions on Harmful Content</h2>
<p>DressDown's AI systems must not be used to generate or disseminate:</p>
<ul>
  <li>Content containing elements of discrimination, racism, sexism, or other forms of hate.</li>
  <li>Violent, pornographic, or defamatory images.</li>
  <li>Disinformation or deepfakes that mislead or harm reputations.</li>
</ul>

<h2>Ethical Limitations and Moderation</h2>
<ul>
  <li>Requests that violate public norms or may cause social harm are automatically blocked.</li>
  <li>Moderation is in place: suspicious activity may be manually reviewed.</li>
  <li>Content that violates the policy is removed, and offenders are blocked.</li>
</ul>

<h2>Copyright Protection</h2>
<ul>
  <li>Generated images must not replicate recognizable styles of artists or photographers without their permission.</li>
  <li>It is prohibited to create works that may infringe on the intellectual property rights of third parties.</li>
</ul>

<h2>Technical Safeguards</h2>
<p>DressDown.me implements a comprehensive set of technical and organizational measures to ensure the secure processing of data related to the use of AI technologies. These measures aim to protect users’ personal data from unauthorized access, loss, alteration, or disclosure, and to ensure compliance with applicable laws.</p>
<p>Key measures include:</p>
<ul>
  <li>Data encryption during transmission and storage using modern security protocols such as TLS/SSL, in line with the recommendations of the European Union Agency for Cybersecurity (ENISA).</li>
  <li>Limiting access to AI systems and personal data only to authorized personnel and partners under confidentiality agreements, in compliance with Article 32 GDPR (Security of Processing).</li>
  <li>Regular updates to software and hardware to eliminate vulnerabilities and prevent cyberattacks.</li>
  <li>Continuous monitoring, auditing, and security system testing to detect and respond to incidents promptly, in accordance with ISO/IEC 27001 information security management standards.</li>
  <li>Ensuring compliance with the GDPR (Regulation (EU) 2016/679) and other applicable EU regulations.</li>
</ul>
<p>AI data processing is conducted in accordance with data minimization (Art. 5 GDPR) and purpose limitation principles, with no retention beyond what is necessary for processing.</p>

<h2>Your Rights</h2>
<p>Under the GDPR, users have the right to:</p>
<ul>
  <li>Access their data.</li>
  <li>Withdraw consent for processing.</li>
  <li>Request deletion or correction of data related to image generation.</li>
</ul>
<p>If you believe your content, image, or data has been used without consent, please contact us at <a href="mailto:dressdown@dressdown.me">dressdown@dressdown.me</a>. We guarantee review and response within 30 calendar days.</p>
`

export default ded
